import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Snack, SnackTheme } from '@main/snackbar/const';
import { SnackbarFacade } from '@main/snackbar/data-access';
import { CUSTOM_ICON_TYPE } from '@shared/models';

@Component({
  selector: 'ui-snack',
  templateUrl: './snack.component.html',
  styleUrls: ['./snack.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SnackComponent {
  @Input() snack: Snack;

  iconType = CUSTOM_ICON_TYPE;
  snackTheme = SnackTheme;

  constructor(private snackbarFacade: SnackbarFacade) {}

  close(): void {
    this.snackbarFacade.closeSnack(this.snack);
  }

  onBtnClick(): void {
    this.snack.button.onClick(this.snack.id);

    if (!this.snack.button.preventClose) {
      this.close();
    }
  }

  /**
   * При нажатии на ссылки, снек должен закрываться
   */
  click(event: Event): void {
    if ((event.target as HTMLElement).tagName === 'A') {
      this.close();
    }
  }
}
